<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <div class="news">
        <div class="detailsTitle">
          <div class="detailsWrap"></div>
          <p>{{ navtitle }}</p>
        </div>
        <el-form>
          <el-form-item label="單集名稱:">
            <div style="display: flex">
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="form.nameCn"
                placeholder="請輸入單集名稱"
                v-show="titleFlag === 'cn'"
              />
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="form.name"
                placeholder="請輸入單集名稱"
                v-show="titleFlag === 'tw'"
              />
              <input
                maxlength="100"
                class="el-input__inner"
                type="text"
                v-model="form.nameEn"
                placeholder="請輸入單集名稱"
                v-show="titleFlag === 'en'"
              />
              <div style="margin-left: 20px; display: flex">
                <div
                  :class="
                    titleFlag == item.value ? 'lglabel lbnone' : 'lglabel'
                  "
                  v-for="item in languageList"
                  :key="item.value"
                  @click="titleFlag = item.value"
                  :style="{
                    backgroundColor: titleFlag == item.value ? '#6C3DEA' : '',
                    color: titleFlag == item.value ? '#fff' : '#6C3DEA',
                  }"
                >
                  {{ item.label }}
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="單集類型:">
            <el-radio-group v-model="form.vodType" @input="changeImg">
              <el-radio :label="0">音頻</el-radio>
              <el-radio :label="1">视频</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="form.vodType == 0 ? '上傳主圖:' : '上傳影片封面圖:'"
            class="picupload"
          >
            <el-upload
              action=""
              :http-request="uploadRequest"
              :headers="{ Authorization: this.$cookie.get('auth') }"
              :with-credentials="true"
              :data="uploadData"
              :on-remove="handleRemove"
              :on-error="$errorImage"
              :file-list="newsList"
              :on-exceed="$handleExceed.bind(this, 18)"
              :on-change="handleChange"
              :before-upload="beforePicUpload"
              :on-progress="uploadImgProcess"
              :limit="0"
              accept=".jpg,.jpeg,.png"
              :multiple="false"
              name="musicImg"
              list-type="picture-card"
            >
              <el-button v-if="!imgUploadFlag" size="small" type="primary"
                >選擇圖片</el-button
              >
              <div slot="tip" class="el-upload__tip">
                支持jpg/png格式(2M以内)
              </div>
              <el-progress
                v-if="imgUploadFlag"
                type="circle"
                :percentage="imgUploadPercent"
                style="margin-top: 10px"
              ></el-progress>
            </el-upload>
          </el-form-item>
          <el-form-item label="上傳影片：" v-show="form.vodType == 1">
            <div style="display: flex; align-items: flex-end">
              <video
                width="50%"
                v-if="VideoUrl.length == 1"
                class="avatar"
                :src="VideoUrl[0].url"
                controls="controls"
              >
                您的浏览器不支持视频播放
              </video>
              <div
                @click="handleVideoRemove()"
                style="
                  cursor: pointer;
                  font-size: 16;
                  color: blueviolet;
                  margin-left: 10px;
                "
                v-if="VideoUrl.length == 1"
              >
                刪除
              </div>
            </div>
            <el-upload
              action=""
              :http-request="uploadRequest"
              :with-credentials="true"
              :headers="{ Authorization: this.$cookie.get('auth') }"
              :on-error="errorVideo"
              :on-exceed="handleVideoExceed"
              :on-remove="handleVideoRemove"
              :on-progress="uploadVideoProcess"
              :file-list="VideoUrl"
              :show-file-list="false"
              :before-upload="beforeVideoUpload"
              :limit="1"
              accept=".mp4"
              :multiple="false"
              name="vedio"
              list-type="picture-card"
            >
              <el-button v-if="!videoFlag" size="small" type="primary"
                >選擇視頻</el-button
              >
              <div slot="tip" class="el-upload__tip">支持mp4格式</div>
              <el-progress
                v-if="videoFlag"
                type="circle"
                :percentage="videoUploadPercent"
                style="margin-top: 10px"
              ></el-progress>
            </el-upload>
            <!-- <div>支持mp4格式</div> -->
          </el-form-item>
          <el-form-item label="上傳音頻:">
            <div
              style="display: flex; align-items: center"
              v-if="audioFile.length > 0"
            >
              <audio
                :src="audioFile[0].url"
                controls
                style="width: 300px"
              ></audio>
              <div
                style="font-size: 14; margin-left: 10px; cursor: pointer"
                @click="handleAudioRemove()"
              >
                删除
              </div>
            </div>
            <el-upload
              action=""
              :http-request="uploadRequest"
              :with-credentials="true"
              :headers="{ Authorization: this.$cookie.get('auth') }"
              :on-error="errorAudio"
              :on-exceed="audiohandleExceed"
              :on-remove="handleAudioRemove"
              :file-list="audioFile"
              :before-upload="beforeAudioUpload"
              :limit="1"
              accept=".mp3,.m4a,.wav"
              :multiple="false"
              name="audio"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">選擇音頻文件</el-button>
              <div slot="tip" class="el-upload__tip">支持mp3/m4a/wav格式</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="定時發佈:">
            <el-switch
              active-color="#6C3DEA"
              v-model="statusTime"
              @change="form.publishTime = ''"
              :disabled="form.status == '已發佈'"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="發佈時間:"
            v-if="statusTime"
            :disabled="form.status == '已發佈'"
          >
            <el-date-picker
              v-model="form.publishTime"
              type="datetime"
              placeholder="選擇時間"
              format="yyyy-MM-dd HH:mm"
              @blur="changeTime()"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="單集介紹:">
            <div class="box_flex">
              <el-input
                type="textarea"
                placeholder="請輸入單集介紹"
                v-model="form.contentCn"
                style="width: 300px"
                resize="none"
                v-show="introduceFlag == 'cn'"
                maxlength="1000"
              />
              <el-input
                type="textarea"
                placeholder="請輸入單集介紹"
                v-model="form.content"
                style="width: 300px"
                resize="none"
                v-show="introduceFlag == 'tw'"
                maxlength="1000"
              />
              <el-input
                type="textarea"
                placeholder="請輸入單集介紹"
                v-model="form.contentEn"
                style="width: 300px"
                resize="none"
                v-show="introduceFlag == 'en'"
                maxlength="1000"
              />
              <div style="margin-left: 20px; display: flex">
                <div
                  :class="
                    introduceFlag == item.value ? 'lglabel lbnone' : 'lglabel'
                  "
                  v-for="item in languageList"
                  :key="item.value"
                  @click="introduceFlag = item.value"
                  :style="{
                    backgroundColor:
                      introduceFlag == item.value ? '#6C3DEA' : '',
                    color: introduceFlag == item.value ? '#fff' : '#6C3DEA',
                  }"
                >
                  {{ item.label }}
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>

        <div class="bottomBtn">
          <el-button @click="$router.go(-1)">取消</el-button>
          <el-button
            type="primary"
            v-throttle="{
              fn: () => {
                submitContent();
              },
              time: 2000,
            }"
            >發佈</el-button
          >
        </div>

        <DiaMess v-if="dialogVisible"></DiaMess>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/editor";
import DiaMess from "@/components/dialog";
import NavBar from "@/components/navBar";
import Mint from "mint-ui";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      navBlock: "靈魂的共鳴 / 合集列表 / 详情",
      navtitle: `${this.$route.query.row ? "編輯單集" : "新增單集"}`,
      audioFile: [],
      showLoading: true,
      form: {
        id: null,
        name: "",
        nameCn: "",
        nameEn: "",
        img: "",
        content: "",
        contentCn: "",
        contentEn: "",
        duration: "",
        audio: "",
        status: "",
        avId: "",
        publishTime: "",
        soulId: this.$route.query.soulId,
        vodType: 0,
        vodAvId: "",
        vod720: "",
        vod4k: "",
        vod: "",
      },
      titleFlag: "cn",
      introduceFlag: "cn",
      languageList: [
        { label: "簡", value: "cn" },
        { label: "繁", value: "tw" },
        { label: "英", value: "en" },
      ],
      newsList: [],
      uploadData: {
        // 上传图片的附加参数
        flag: "xw",
      },
      statusTime: false,
      imgUploadFlag: false, // 主图上传进度条显示flag
      imgUploadPercent: "", // 主图上传进度条
      dialogVisible: false,
      soundName: "",
      VideoUrl: [], // 视频类型的video
      videoFlag: false,
      videoTokenTimer: null, // 视频轮询定时器
      loadingInstance: null, // 视频轮询loading
      UHD_WIDTH: 3840,
      UHD_HEIGHT: 2160,
    };
  },
  mounted() {
    let _this = this;
    if (_this.$route.query.row) {
      // 如果有row参数，说明是编辑状态
      _this.form = {
        ...JSON.parse(decodeURIComponent(_this.$route.query.row)),
        soulId: _this.$route.query.soulId,
      };
      console.log(_this.form);

      _this.audioFile = [{ url: _this.form.audio }];
      _this.VideoUrl = [{ url: _this.form.vod }];
      _this.newsList = [{ url: _this.form.img }];
      _this.statusTime = _this.form.status == "待發佈" ? true : false;
      if (_this.form.vodType == 1) {
        // _this.videoFlag = true;
      }
      document.querySelectorAll(".el-upload").forEach((el) => {
        el.style.display = "none";
      });
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    messageTips(msg, type) {
      return this.$message({
        center: true,
        message: msg,
        type: type,
        duration: 2000,
      });
    },
    submitContent() {
      let _this = this;
      if (!_this.form.nameCn || !_this.form.name || !_this.form.nameEn) {
        _this.messageTips("請輸入單集名稱", "error");
        return;
      }
      if (_this.newsList.length === 0) {
        _this.messageTips(
          this.form.vodType == 0 ? "請上傳主圖" : "請上傳影片封面圖",
          "error"
        );
        return;
      }
      if (_this.form.vodType == 1) {
        if (_this.VideoUrl.length === 0) {
          _this.messageTips("請上傳影片", "error");
          return;
        }
      }
      if (_this.audioFile.length === 0) {
        _this.messageTips("請上傳音頻文件", "error");
        return;
      }
      if (_this.form.vodType == 1) {
        if (!_this.form.vodAvId) {
          _this.messageTips("視頻憑證獲取失敗，請重新上傳", "error");
          return;
        }
      } else {
        if (!_this.form.avId) {
          _this.messageTips("音頻憑證獲取失敗，請重新上傳", "error");
          return;
        }
      }

      if (_this.statusTime) {
        if (!_this.form.publishTime) {
          _this.messageTips("請選擇發佈時間", "error");
          return;
        } else {
          _this.form.publishTime = this.$getTime(_this.form.publishTime);
        }
      } else {
        _this.form.publishTime = _this.$getTime(new Date().getTime());
      }
      if (
        !_this.form.contentCn ||
        !_this.form.content ||
        !_this.form.contentEn
      ) {
        _this.messageTips("請輸入單集介紹", "error");
        return;
      }
      _this.form.status = !_this.statusTime ? 1 : 2;
      // if(_this.statusTime){

      // }

      _this
        .$post(
          `/request/soul/resonance/song/operate`,
          _this.form,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            _this.$propMessage(
              this.$route.query.row ? "编辑成功" : "發佈成功",
              "success",
              function () {
                _this.dialogVisible = false;
                _this.$router.go(-1);
              }
            );
            _this.form = {};
            _this.titleFlag = "cn";
            _this.introduceFlag = "cn";
          } else {
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    //获取音频上传凭证
    getAudioToken(e, type) {
      const params = {
        url: e,
        title: this.soundName,
        type: 1,
        vodType: type == "video" ? 1 : 0,
      };
      this.$post(
        "/request/soul/resonance/submit/vod",
        params,
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code === "00000") {
          if (this.form.vodType == 0) {
            this.form.avId = res.data.avId;
          } else {
            if (type == "video") {
              //十秒一次
              this.form.vodAvId = res.data.avId;
              this.startPollVideoToken(res.data.avId);
            } else {
              this.form.avId = res.data.avId;
            }
          }
        } else {
          this.messageTips(res.message, "error");
        }
      });
    },
    handleVideoExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一個視頻", "error", function () {
        _this.dialogVisible = false;
      });

      return false;
    },
    changeImg() {
      document.querySelectorAll(".el-upload").forEach((el) => {
        el.style.display = "inline-block";
      });
      if (this.newsList.length > 0) {
        this.newsList.splice(0, 1);
      }
      this.audioFile = [];
      this.videoFlag = false;
      this.VideoUrl = [];
      this.form.audio = "";
      this.form.avId = "";
      this.form.vodAvId = "";
      this.form.vod720 = "";
      this.form.vod4k = "";
      this.form.vod = "";
    },
    // 启动轮询（先清理旧的，防止重复轮询）
    startPollVideoToken(avId) {
      this.loadingInstance = Loading.service({
        text: "視頻轉碼中，請稍候",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.stopPollVideoToken();
      this.getVideoToken(avId);
    },
    //轮询接口
    getVideoToken(e) {
      let _this = this;
      _this
        .$get(
          `/request/soul/resonance/vod/transcoding?avId=${e}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            if (res.data.status == 1) {
              this.loadingInstance.close();
              _this.form.vod720 = res.data.vod720;
              _this.form.vod4k = res.data.vod4k;
              _this.messageTips("視頻轉碼成功", "success");
            } else {
              setTimeout(() => {
                _this.getVideoToken(e);
              }, 10000);
            }
          } else {
            _this.stopPollVideoToken();
            _this.messageTips(res.message, "error");
          }
        })
        .catch((err) => {
          // 请求异常，停止轮询
          _this.stopPollVideoToken();
          _this.messageTips(err, "error");
        });
    },
    stopPollVideoToken() {
      if (this.videoTokenTimer) {
        clearTimeout(this.videoTokenTimer);
        this.videoTokenTimer = null;
      }
    },
    // 视频进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
    },
    getVideoMeta(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const video = document.createElement("video");
        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;

        const cleanup = () => {
          URL.revokeObjectURL(url);
          video.removeAttribute("src");
          video.load();
        };

        video.onloadedmetadata = () => {
          const width = video.videoWidth;
          const height = video.videoHeight;
          cleanup();
          if (!width || !height) {
            reject(new Error("无法读取视频分辨率"));
          } else {
            resolve({ width, height });
          }
        };

        video.onerror = () => {
          cleanup();
          reject(new Error("视频加载失败，可能格式不支持"));
        };

        video.src = url;
      });
    },

    // 判断是否达到 4K（兼容横竖屏）
    is4K(width, height) {
      const shortSide = Math.min(width, height);
      const longSide = Math.max(width, height);
      return shortSide >= this.UHD_HEIGHT && longSide >= this.UHD_WIDTH;
    },

    async beforeVideoUpload(file) {
      let _this = this;
      const isVideo = file.type.startsWith("video/");
      if (!isVideo) {
        this.$message.error("请上传视频文件");
        return Promise.reject(new Error("非视频文件")); // 不能用 return false
      }
      try {
        const { width, height } = await this.getVideoMeta(file);

        const orientation = width >= height ? "横屏" : "竖屏";
        const resolutionText = `${width}×${height}（${orientation}）`;

        if (!this.is4K(width, height)) {
          this.$message.error(`当前视频未达到4K分辨率，请重新上传`);
          // 阻止上传
          return Promise.reject(new Error("未达到4K分辨率"));
        }
        return true;
      } catch (err) {
        this.$message.error(err.message || "视频解析失败，请重新上传");
        return Promise.reject(err);
      }
    },
    handleVideoRemove(file) {
      this.VideoUrl = [];
      this.form.vodAvId = "";
      this.form.vod720 = "";
      this.form.vod4k = "";
      this.form.vod = "";
      this.videoFlag = false;
      document.getElementsByClassName("el-upload")[1].style.display =
        "inline-block";
      return false;
    },
    // 上传图片之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "上傳圖片只能是jpg或者png格式",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );

        return false;
      }

      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過2MB", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }

      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
            _this.$imageConversion
              .compress(file, {
                quality: 0.3,
                width: 3000,
              })
              .then((res) => {
                resolve(res);
              });
          } else {
            resolve(file);
          }
        };
        img.src = _URL.createObjectURL(file);
      });
      return isJPG && isLt2M && isWidth;
    },

    changeTime() {
      if (!this.form.publishTime) return;
      let time = new Date(this.form.publishTime).getTime();
      let now = new Date().getTime();
      if (time < now) {
        this.dialogVisible = true;
        this.$propMessage("請選擇大於當前時間", "error", () => {
          this.dialogVisible = false;
          this.form.publishTime = "";
        });
      }
    },
    // 图片上传进度条
    uploadImgProcess(event, file, newsList) {
      this.imgUploadFlag = true;
      this.imgUploadPercent = file.percentage.toFixed(0);
    },
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        let fileWay = "";
        if (
          extensionName === ".mp4" ||
          extensionName === ".MP4" ||
          extensionName === ".Mp4" ||
          extensionName === ".mP4"
        ) {
          fileWay = "resource/video/";
        } else if (extensionName === ".mp3") {
          fileWay = "resource/audio/";
        } else {
          fileWay = "resource/image/";
        }
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        self.soundName = option.file.name;
        // 执行上传
        self.$createOssClient().then((client) => {
          Mint.Indicator.open({
            text: "請稍候",
            spinnerType: "snake",
          });
          client
            .multipartUpload(fileName, file, {
              progress: function (p) {
                if (
                  extensionName === ".mp4" ||
                  extensionName === ".MP4" ||
                  extensionName === ".Mp4" ||
                  extensionName === ".mP4"
                ) {
                  if (p > 0) {
                    self.videoFlag = true;
                  } else if ((p = 1)) {
                    self.videoFlag = false;
                  }
                  self.videoUploadPercent = Math.floor(p * 100);
                } else {
                  if (p > 0) {
                    self.imgFlag = true;
                  } else if ((p = 1)) {
                    self.imgFlag = false;
                  }
                  self.imgUploadPercent = Math.floor(p * 100);
                }
              },
              headers: { "Cache-Control": "public" },
            })
            .then(
              (val) => {
                if (val.res.statusCode === 200) {
                  Mint.Indicator.close();
                  if (option.filename === "vedio") {
                    self.VideoUrl.push({
                      name: "video.mp4",
                      url: self.$GLOBAL.picFileUrl + val.name,
                    });
                    // self.$convertVideo(val.name).then((res) => {});
                    this.getAudioToken(self.VideoUrl[0].url, "video");
                    document.getElementsByClassName(
                      "el-upload"
                    )[1].style.display = "none";
                    self.form.vod = self.VideoUrl[0].url;
                  } else if (option.filename === "titlePage") {
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                    self.titlePictureUrl.push({
                      name: "image.jpeg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic,
                    });
                    //cdn预热
                    self.$cdnFun(self.titlePictureUrl[0].url).then((res) => {});
                  } else if (option.filename === "musicImg") {
                    //cdn预热
                    self.newsList.push({
                      name: "img.jpg",
                      url: self.$GLOBAL.picFileUrl + val.name,
                    });
                    self.$cdnFun(self.newsList[0].url).then((res) => {
                      self.form.img = self.newsList[0].url;
                    });
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                    return val;
                  } else if (option.filename === "audio") {
                    self.audioFile.push({
                      name: file.name,
                      url: self.$GLOBAL.picFileUrl + val.name,
                    }); // 展示图片
                    this.getAudioToken(self.audioFile[0].url, "audio");
                    self.$cdnFun(self.audioFile[0].url).then((res) => {
                      document.getElementsByClassName(
                        "el-upload"
                      )[2].style.display = "none";
                      this.form.audio = this.audioFile[0].url;
                    });
                  }
                } else {
                  option.onError("上传失败");
                }
              },
              (err) => {
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    errorVideo(data) {
      this.$propMessage(data, "error");
    },
    audiohandleExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一條音頻", "error", function () {
        _this.dialogVisible = false;
      });
      return false;
    },
    //移除音頻
    handleAudioRemove() {
      if (this.audioFile.length === 0) return;
      this.audioFile = [];
      this.form.audio = "";
      this.form.avId = "";
      document.getElementsByClassName("el-upload")[2].style.display =
        "inline-block";
    },
    beforeAudioUpload(file) {
      let _this = this;
      const isAudio = file.type.includes("audio");
      if (!isAudio) {
        _this.dialogVisible = true;
        _this.$propMessage("請上傳音頻文件", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      } else {
        return new Promise((resolve, reject) => {
          var content = file;
          //获取录音时长
          var url = URL.createObjectURL(content);
          //经测试，发现audio也可获取视频的时长
          var audioElement = new Audio(url);
          audioElement.addEventListener("loadedmetadata", (_event) => {
            let time = parseInt(audioElement.duration);
            let minuteTime = parseInt(time / 60);
            let secondTime = parseInt(time % 60);
            _this.form.duration =
              (minuteTime < 10 ? "0" + minuteTime : minuteTime) +
              ":" +
              (secondTime < 10 ? "0" + secondTime : secondTime);
            // console.log(file)
            resolve(file);
          });
        });
      }
    },
    //音频上传失败
    errorAudio() {
      let _this = this;
      _this.dialogVisible = true;
      _this.form.duration = "";
      _this.audioFile = [];
      _this.$propMessage("上傳失敗！", "error", function () {
        _this.dialogVisible = false;
      });
    },
    // 图片列表发生改变的回调函数
    handleChange(file, newsList) {
      if (newsList.length > 1) {
        newsList.splice(0, 1);
      }
    },

    handleRemove(file, fileList) {
      this.$deleteUidItem(file.uid, this.newsList);
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
    },
  },
  components: {
    Editor,
    DiaMess,
    NavBar,
  },
};
</script>
<style scoped lang="less">
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  background: #9e9e9e;
}
.news .excel_list {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  .excel_input {
    position: relative;
    width: 174px;
    height: 36px;
    border: 1px solid #ababab;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      cursor: pointer;
    }
  }

  .add_btn {
    margin-left: 10px;
    width: 80px;
    height: 36px;
    border: 1px solid #ababab;
    box-sizing: border-box;
    text-align: center;
    line-height: 36px;
    border-radius: 4px;
    cursor: pointer;
  }

  input[type="file"]::-webkit-file-upload-button {
    cursor: pointer;
  }
}
</style>
<style scoped lang="less">
.el-form-item__content {
  white-space: normal;
}
.el-upload-list--picture-card {
  white-space: normal;
}
.box_flex {
  display: flex;
  align-items: center;
}
.label_text {
  font-size: 14px;
  cursor: pointer;
  width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  color: #000000;
}
/deep/.el-textarea__inner {
  line-height: 14px !important;
  height: 130px !important;
}
.lglabel {
  height: 38px;
  line-height: 38px;
  text-align: center;
  padding: 0 20px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.lbnone {
  border-left-width: 0px;
  border-right-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jjsoul/addCollection.vue